import React, { useState, useEffect } from "react";
import { GradientBorderBox } from "../GradientBorderBox";
import Input from "../Input";
import { CheckedIcon } from "../SVGIcons";
import { useTheme } from "../../context/ThemeContext";
import { IAutoStakeResponse } from "../../utils/types";
import { apiServices } from "../../utils/apiServices";
import { toast } from "react-toastify";
import AutoStakeListTable from "../trader/AutoStakeListTable";
import { useParams } from "react-router-dom";
import ConnectWalletBtn from "../ConnectWalletBtn";
import { SN_VAL_ADDRS } from "../../utils/const";
import { useEVMContext } from "../../context/EVMContext";

const Checkbox = ({ label, isChecked, onChange }: { label: string, isChecked: boolean, onChange: () => void }) => {
    const { isDark } = useTheme();
    return <div className="flex items-center gap-[8px] cursor-pointer" onClick={() => onChange()}>
        <div className="min-w-[24px] h-[24px] flex items-center justify-center">
            {isChecked ? <CheckedIcon fillColor={isDark ? "white" : "black"} /> : <div className="w-[20px] h-[20px] rounded-full border-[2px] border-black dark:border-white" />}
        </div>
        <label className="text-[14px] text-black dark:text-white select-none cursor-pointer">{label}</label>
    </div>
}

const Item = ({ title, children }: { title: React.ReactNode, children: React.ReactNode }) => {
    return <div className="flex flex-col gap-[12px] w-full">
        <h3 className="text-[14px] text-black dark:text-white">{title}</h3>
        {children}
    </div>
}
const AutoPanel = ({ subnetInfo, refreshFunc }: { subnetInfo: any; refreshFunc: () => void; }) => {
    const [isRepeat, setIsRepeat] = useState(false);
    const [repeatCount, setRepeatCount] = useState(-1);
    const [autoStakes, setAutoStakes] = useState<IAutoStakeResponse[]>([]);
    const { id } = useParams<{ id: string }>();
    const [stakeAmount, setStakeAmount] = useState('');
    const [stakePrice, setStakePrice] = useState<string>('');
    const [unstakePrice, setUnstakePrice] = useState<string>('');
    const { signer, accounts } = useEVMContext();

    const getAutoStakes = async () => {
        if (!accounts[0]) {
            return;
        }
        try {
            const res = await apiServices.stakes.getAutoStakes(accounts[0] || '');
            setAutoStakes(res.filter(stake => stake.subnet_id === Number(id)));
        } catch (error) {
            console.error('Error fetching auto stakes:', error);
            toast.error('Error fetching auto stakes');
        }
    }

    const stopAutoStake = async (stakeId: number) => {
        // if (!accounts[0]) {
        //     toast.error('Error: active account is not defined');
        //     return;
        // }
        // const signature = localStorage.getItem(accounts[0] || '');
        // try {
        //     const res = await apiServices.stakes.stopAutoStake(stakeId, accounts[0] || '', signature);
        //     if (res.auto_stake_id === stakeId) {
        //         toast.success('Auto stake stopped successfully!');
        //         getAutoStakes(); // Refresh the list after stopping
        //     } else {
        //         toast.error('Error: Failed to stop auto stake');
        //     }
        // } catch (error) {
        //     console.error('Error stopping auto stake:', error);
        //     toast.error('Error stopping auto stake');
        // }
    }

    const handleAutoStake = async () => {
        toast.info("Auto Staking function will be available from the next version.");
        // if (!accounts[0]) {
        //     toast.error('Error: active account is not defined');
        //     return;
        // }
        // const signature = localStorage.getItem(accounts[0] || '');
        // if (!signature) {
        //     toast.error('Error: Signature is not defined');
        //     return;
        // }
        // apiServices.stakes.autoStake({
        //     trader_id: accounts[0] || '',
        //     subnet: Number(id),
        //     val_addr: SN_VAL_ADDRS[Number(id)] || '',
        //     stake_amount: Number(stakeAmount),
        //     stake_price: Number(stakePrice),
        //     unstake_price: Number(unstakePrice),
        //     repeat_cnt: repeatCount,
        // }, signature).then((res: any) => {
        //     if (res.auto_stake_id) {
        //         toast.success('Auto staking started!');
        //         getAutoStakes()
        //         refreshFunc();
        //     } else {
        //         toast.error('Error: Auto staking failed!');
        //     }
        // })
    }

    // useEffect(() => {
    //     getAutoStakes()
    // }, [accounts[0]]);

    return <GradientBorderBox>
        <div className="flex flex-col gap-[24px]">
            <div className="flex gap-[24px]">
                <Item title="Stake or Unstake Amount(τ)" >
                    <Input props={{ type: "number", placeholder: "Enter stake amount", value: stakeAmount, onChange: (e) => setStakeAmount(e.target.value) }} />
                </Item>
                <Item title={`Stake Price (Current SN Price:${subnetInfo.price?.toString() || "0"})`} >
                    <Input props={{ type: "number", placeholder: "Enter stake price", value: stakePrice, onChange: (e) => setStakePrice(e.target.value) }} />
                </Item>
                <Item title="Unstake Price" >
                    <Input props={{ type: "number", placeholder: "Enter unstake amount", value: unstakePrice, onChange: (e) => setUnstakePrice(e.target.value) }} />
                </Item>
            </div>
            <div className="flex flex-col items-end">
                <div className="flex gap-[24px] w-full">
                    <Checkbox label="Repeat Times" isChecked={!isRepeat} onChange={() => setIsRepeat(false)} />
                    <Input
                        props={{
                            type: "number",
                            placeholder: "N",
                            value: repeatCount,
                            onChange: (e) => setRepeatCount(Number(e.target.value))
                        }}
                        className="!w-[50px]"
                    />
                    <Checkbox label="Repeat until stopped" isChecked={isRepeat} onChange={() => {
                        setIsRepeat(true)
                        setRepeatCount(-1)
                    }} />
                </div>
                {accounts[0] ? (
                    <button
                        onClick={handleAutoStake}
                        className="w-fit py-[14px] px-[40px] rounded-[100px] font-medium text-[14px] leading-[17px] bg-[#0FE] text-black hover:opacity-80 transition-all duration-200">
                        Start
                    </button>
                ) : (
                    <ConnectWalletBtn className="rounded-[8px]" />
                )}
            </div>
        </div>
        {accounts[0] && (
            <AutoStakeListTable
                autoStakes={autoStakes}
                stopAutoStake={stopAutoStake}
            />
        )}
    </GradientBorderBox>;
};

export default AutoPanel;
